<template>
  <div class="pagination-element">
    <div class="content" @click="$emit('onClicked')">...</div>
  </div>
</template>
<script lang="ts" setup>
defineEmits<{
  (event: 'onClicked'): void
}>()
// currently not emitting anything, needs scoping of the event
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';

.pagination-element {
  display: flex;
  width: 24px;
  height: 48px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  color: variables.$color-primary;
  border-radius: 8px;
  box-sizing: border-box;
}
.content {
  @include font-mixins.desktop-bold-paragraph;
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  box-sizing: border-box;
}
</style>
